import React from "react";
import {deleteFixedCust, getFixedCusts, saveFixedCust, updateFixedCust} from "../../services/fixedCustsService"; // ajuste o caminho
import { useCompany } from "../../contexts/CompanyContext";
import CrudTable from "../../components/Custom/CrudTable";
import { Autocomplete, TextField } from "@mui/material";

import { opcoesCustosFixos } from '../../constants/opcoesCustos';

const FixedCostList = () => {
  const { company } = useCompany();
  
  const columns = [
    { key: "descricao", label: "Descrição" },
    { key: "valor", label: "Valor" , render: (v) => `R$ ${parseFloat(v).toFixed(2)}`}
  ];

  const fields = [
    { name: "descricao", label: "Descrição" },
    { name: "valor", label: "Valor", type: "number" }
  ];

  const service = {
    getAll: (companyId) => getFixedCusts(companyId),
    create: (companyId, data) => saveFixedCust(companyId, data),
    update: (companyId, id, data) => updateFixedCust(companyId, id, data),
    remove: (companyId, id) => deleteFixedCust(companyId, id),
  };

  const renderForm = (item, handleChange, setItem) => (
    <>
      <Autocomplete
        size="small"
        freeSolo
        options={opcoesCustosFixos}
        value={item.descricao || ""}
        sx={{ width: "100%", mt: 1 }}
        onInputChange={(e, newValue) => setItem({ ...item, descricao: newValue })}
        renderInput={(params) => <TextField {...params} label="Descrição" fullWidth />}
      />

      <TextField
        fullWidth
        margin="normal"
        type="number"
        label="Valor"
        name="valor"
        value={item.valor || ""}
        onChange={handleChange}
      />
    </>
  );

  return (
    <CrudTable
      title="Custos fixos"
      columns={columns}
      fields={fields}             
      service={service}
      entityName="Custo Fixo"
      companyId={company.companyId}
      renderForm={renderForm}      
    />
  );
};

export default FixedCostList;
